export enum VideoCallManagementVideoQualityEnum {
  "Low" = 1,
  "Medium" = 2,
  "High" = 3,
  "Auto" = 4,
}

export enum VideoCallManagementServerRegionEnum {
  "North America" = 1,
  "Europe" = 2,
  "Asia" = 3,
  "Auto" = 4,
}

export enum VideoCallManagementCallDurationEnum {
  "30 mins" = 1,
  "1 hour" = 2,
  "2 hours" = 3,
  "Unlimited" = 4,
}

export enum VideoCallManagementEnum {
  // Default values
  DEFAULT_CALL_DURATION = VideoCallManagementCallDurationEnum["1 hour"],
  DEFAULT_VIDEO_QUALITY = VideoCallManagementVideoQualityEnum.Auto,
  DEFAULT_SERVER_REGION = VideoCallManagementServerRegionEnum.Auto,
}
